import { apiSlice } from "../../apiSlice";

//La galeria y el visor viven en HOME/TABLEROS, no en la pantalla de Paramgen, asi que el
//modulecima que arma prepareHeaders desde moduleURL llega con el modulo en que navega el
//usuario (Usuarios) y el API Gateway enruta a la Lambda equivocada. Estos dos endpoints
//fijan el header a mano; prepareHeaders lo respeta porque solo lo pone si no viene ya.
const headers = { Modulecima: "Paramgen" };

export const dashestxApiSlice = apiSlice.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    getDashboards: builder.query({
      query: () => `/Paramgen/dashestx`,
      providesTags: ["Dashestx"],
    }),
    getDashboardById: builder.query({
      query: (DASHIDXX) => `/Paramgen/dashestx/${DASHIDXX}`,
      providesTags: ["Dashestx"],
    }),
    //Las mutaciones invalidan dos tags a proposito: "Create" es el que provee
    //getDataTracking, y sin el la parametrica no se vuelve a pintar; "Dashestx" refresca
    //la galeria de la pestana TABLEROS, que se alimenta de getVisibles.
    createDashboard: builder.mutation({
      //Multipart: el tablero se crea junto con el HTML de su primera version
      query: (formData) => ({
        url: `/Paramgen/dashestx`,
        method: "POST",
        body: formData,
        formData: true,
      }),
      invalidatesTags: ["Create", "Dashestx"],
    }),
    updateDashboard: builder.mutation({
      query: (parameters) => ({
        url: `/Paramgen/dashestx/${parameters.DASHIDXX}`,
        method: "PUT",
        body: parameters,
      }),
      invalidatesTags: ["Create", "Dashestx"],
    }),
    activeInactiveDashboard: builder.mutation({
      query: (parameters) => ({
        url: `/Paramgen/dashestx/${parameters.DASHIDXX}/${parameters.REGESTXX}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Create", "Dashestx"],
    }),
    uploadVersion: builder.mutation({
      query: ({ DASHIDXX, formData }) => ({
        url: `/Paramgen/dashestx/${DASHIDXX}/upload`,
        method: "POST",
        body: formData,
        formData: true,
      }),
      invalidatesTags: ["Create", "Dashestx"],
    }),
    getVisibles: builder.query({
      query: () => ({ url: `/Paramgen/dashestx/visibles`, headers }),
      providesTags: ["Dashestx"],
    }),
    //Devuelve la URL firmada de S3, no el HTML: el ALB corta en 1 MiB las
    //respuestas de una Lambda y un tablero pesa bastante mas.
    getContent: builder.query({
      query: ({ DASHIDXX, VERPERXX }) => ({
        url: VERPERXX
          ? `/Paramgen/dashestx/${DASHIDXX}/content/${VERPERXX}`
          : `/Paramgen/dashestx/${DASHIDXX}/content`,
        headers,
      }),
    }),
  }),
});

export const {
  useGetDashboardsQuery,
  useGetDashboardByIdQuery,
  useCreateDashboardMutation,
  useUpdateDashboardMutation,
  useActiveInactiveDashboardMutation,
  useUploadVersionMutation,
  useGetVisiblesQuery,
  useLazyGetContentQuery,
} = dashestxApiSlice;
